import { createReducer } from "@reduxjs/toolkit";
import { resetAll, resetNavigationState, setNavigationItems, toggleNavigationItem, } from "../actions";
function createInitialState() {
    return {
        resetKey: Date.now().toString(),
        expandedItems: {}, // Initially, no items are expanded
        navigationItems: [], // Initially, no items are in the expanded list
    };
}
function serializeId(item) {
    return JSON.stringify(item, Object.keys(item).sort());
}
export const configurationNavigationReducer = createReducer(createInitialState(), (builder) => {
    builder
        .addCase(toggleNavigationItem, (state, action) => {
        const { item, enable } = action.payload;
        const itemId = serializeId(item);
        // Toggle or explicitly set the expanded state
        const isExpanded = enable !== null && enable !== void 0 ? enable : !state.expandedItems[itemId];
        state.expandedItems[itemId] = isExpanded;
    })
        .addCase(setNavigationItems, (state, action) => {
        const items = action.payload;
        // Mark all items as expanded
        items.forEach((item) => {
            const itemId = serializeId(item);
            state.expandedItems[itemId] = true;
        });
        // Replace the expandedItemsList with the new items
        state.navigationItems = [...items];
    })
        .addCase(resetNavigationState, () => {
        return createInitialState();
    })
        .addCase(resetAll, () => {
        return createInitialState();
    });
});
export const selectIsItemExpanded = (expandedItems, item) => expandedItems[serializeId(item)];
//# sourceMappingURL=configurationNavigationReducer.js.map